import { RootState } from '../store';

export const actionSelector = (state: RootState) => state.action;

export const forgotPassword = (state: RootState) => state.action.forgotPassword;

export const passwordTemporary = (state: RootState) =>
  state.action.temporayPassword;
